import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import './styles/index.less'
import apiFetch from './config/apiFetch'
import { Notification,Cascader,Tabs,TabPane,Checkbox,CarouselItem,Input,Pagination,Option,Switch,InputNumber,Radio ,Select,Popover,Message,Submenu,Row,Col,Menu,MenuItem,MenuItemGroup,Container,Header,Aside,Main,Table,TableColumn,Button,Badge,Dialog,Breadcrumb,BreadcrumbItem,Dropdown,DropdownMenu,DropdownItem,Upload, MessageBox,Image,Loading} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Print from 'vue-print-nb';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import XLSX from 'xlsx';

import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {downloadFile} from '@/util/common.js'
import "./styles/global.less";

Vue.use(ElementUI)
Vue.use(VueDirectiveImagePreviewer)
Vue.use(CarouselItem).use(Checkbox).use(Tabs).use(TabPane).use(Cascader).use(InputNumber ).use(Switch).use(Pagination).use(Input).use(Option).use(Radio).use(Select).use(Popover).use(Submenu).use(Row).use(Col).use(Menu).use(MenuItem).use(MenuItemGroup).use(Container).use(Header).use(Aside).use(Main).use(Table).use(TableColumn).use(Button).use(Badge).use(Dialog).use(Breadcrumb).use(BreadcrumbItem).use(Dropdown).use(DropdownMenu).use(DropdownItem).use(Upload).use(Image)
Vue.use(Print);
Vue.use(XLSX);
Vue.use(Loading);
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification
Vue.config.productionTip = false
Vue.prototype.$apiFetch =  apiFetch
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.downloadFile = downloadFile
Vue.component(CollapseTransition.name, CollapseTransition)
// 设置浏览器标题
Vue.directive('title', {
  // inserted: function (el) {
  //   console.log(el)
  //   document.title = el.dataset.title
  // }
  bind: function (el) {
    document.title = el.dataset.title
  }
})
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
});
router.afterEach((to) => {
  NProgress.done();
  let title = '';
  if(to.meta && to.meta.title){
    title = to.meta.title;
  }
  // 页面标题
  document.getElementsByTagName('title')[0].innerText = title+' - 智能柜控制系统';

});

// 注册component全局组件
const requireComponents = require.context('./components/global', true, /.vue$/);
Vue.use({
  install:function (Vue){
    requireComponents.keys().forEach(function (n) {
      const _n = n.replace(/\.\/|\.vue/g,'')
      //if(_n.indexOf('_') === 0) return;
      let name = _n.split('/')
      name = name[name.length-1]
      name = name.replace(name[0],name[0].toUpperCase())

      Vue.component(name,requireComponents(n).default)
    });
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


